import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackRoute } from './bootEntry';

// Tells bootEntry which in-memory route is showing, so the service-worker
// reload restores the boot address only while the user is still on it.
export function BootRouteTracker(): null {
  const location = useLocation();
  const route = location.pathname + location.search;
  useEffect(() => { trackRoute(route); }, [route]);
  return null;
}
